var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-box"},[_c('div',{staticClass:"titleBox"},[_c('p',{staticClass:"nickname"},[_vm._v("欢迎登陆「"+_vm._s(_vm.userInfo.admin.name)+"」")]),_c('p',{staticClass:"title"},[_vm._v("两年半后台管理系统")])])])}
var staticRenderFns = []

export { render, staticRenderFns }